import { Operand } from '../entities/operand.entity';
import { StructuredQuery } from '../entities/structured-query.entity';
import { UrlQueryParams } from '../entities/url-query-params.entity';
import { GenerateStructuredQueryFromAdvancedSearchTerm } from './structured-query.helper';
import { UrlQueryParamsConverter } from './url-query-params-converter.helper';

export function GenerateQueryParamsFromAdvancedSearchTerm(
    dottedKey: string,
    values: string[],
    operand: Operand = Operand.Include
): UrlQueryParams {
    const structuredQuery: StructuredQuery = GenerateStructuredQueryFromAdvancedSearchTerm(dottedKey, values, operand);
    return UrlQueryParamsConverter.generateQueryParams(structuredQuery);
}
